import { PORT_COST_MISSING_PRIMARY_ATTRIBUTE_KEY } from '../../hooks/usePortCostEstimates';
import type { LatestExternalPortCostEstimates } from '../../hooks/usePortCostEstimates';
import type { VesselAttributeId } from '../../../graphql';

export type LatestHistoricalPortCostEstimates = {
  cost: number | undefined;
  currency: string;
};

export function getLatestHistoricalPortCost(
  portCallLocationName: string,
  primaryVesselAttributeId: VesselAttributeId | null | undefined,
  latestByPrimaryAttributeId: LatestExternalPortCostEstimates,
): LatestHistoricalPortCostEstimates | undefined {
  const latestByAttribute = latestByPrimaryAttributeId.get(
    portCallLocationName.toUpperCase(),
    primaryVesselAttributeId?.toString() ??
      PORT_COST_MISSING_PRIMARY_ATTRIBUTE_KEY,
  );

  if (latestByAttribute && latestByAttribute.portCost !== undefined) {
    return {
      cost: Math.round(latestByAttribute.portCost),
      currency: latestByAttribute.currency,
    };
  }

  return undefined;
}
